<template>
    <div>sdsdsdsd</div>
</template>


<script>

import axios from "axios";
import router from "@/router";


export default {
    name: 'Logout',
    props: {},
    mounted() {
        axios.post("/api/logout")
            .then(() => {
                    this.$store.commit("auth/SET_EMAIL", '');
                    this.$store.commit("auth/SET_AUTHENTICATED", false)
                    this.$toast.success("You have been logged out successfully")
                    router.push({path: '/'})
                }
            )
            .catch(() => {
                }
            )
    },
    metaInfo() {
        return {
            title: "Logout",
            meta: [
                { name: 'description', content:  'Testing 123'},
                /*{ property: 'og:title', content: "Epiloge - Build your network in your field of interest"},
                */
            ]
        }
    }
}
</script>


